import React, { PureComponent } from 'react';
import QmImage from '../../../components/Image/QmImage';
import qmStyles from '../../../theme/qmStyles';

import componentStyles from './PersonalInfoProtectInfo.scss';

class PersonalInfoProtectInfo extends PureComponent {
  render() {
    return (
      <div className={componentStyles.container}>
        <QmImage src="static/onboarding/lock-star.png" width={45} height={66} />
        <span className="flex-1" style={{ marginLeft: qmStyles.gutter }}>
          We're committed to protecting your personal info. Your data will
          always belong to you, and it will only be used to customize your
          Quartermaster experience.
        </span>
      </div>
    );
  }
}

export default PersonalInfoProtectInfo;
